import React, { useState } from "react";
import { Modal, Button, Row, Col, Select } from "antd";
import { FormOutlined, ThunderboltOutlined, CopyOutlined } from "@ant-design/icons";
import "./RegistrationSetupModal.css";

const { Option } = Select;

const RegistrationSetupModal = ({
    visible,
    onCancel,
    onSelectManual,
    onSelectWizard,
    existingRegistrations = []
}) => {
    const [selectedCloneId, setSelectedCloneId] = useState(undefined);

    const handleWizardClick = () => {
        onSelectWizard(selectedCloneId);
    };

    return (
        <Modal
            title="New Registration Setup"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={700}
            centered
        >
            <div className="setup-modal-content">
                <p style={{ marginBottom: 24, fontSize: 16, textAlign: "center" }}>
                    How would you like to set up your new registration?
                </p>

                <Row gutter={[24, 24]}>
                    <Col span={12}>
                        <div className="setup-option-card" onClick={onSelectManual}>
                            <div className="setup-option-icon">
                                <FormOutlined style={{ fontSize: 48, color: "#1890ff" }} />
                            </div>
                            <h3>Manual Setup</h3>
                            <p>Configure all settings yourself using the tabs interface</p>
                            <Button type="default" block size="large">
                                Manual Setup
                            </Button>
                        </div>
                    </Col>

                    <Col span={12}>
                        <div className="setup-option-card">
                            <div className="setup-option-icon">
                                <ThunderboltOutlined style={{ fontSize: 48, color: "#7FB522" }} />
                            </div>
                            <h3>Setup Wizard</h3>
                            <p>Step-by-step guided setup for easier configuration</p>

                            {existingRegistrations.length > 0 && (
                                <div style={{ marginBottom: 16 }}>
                                    <div style={{ marginBottom: 8, textAlign: "left", fontSize: 12, color: "#666" }}>
                                        <CopyOutlined style={{ marginRight: 4 }} />
                                        Clone from existing (optional):
                                    </div>
                                    <Select
                                        placeholder="Start from scratch"
                                        style={{ width: "100%" }}
                                        value={selectedCloneId}
                                        onChange={setSelectedCloneId}
                                        allowClear
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        {existingRegistrations.map(reg => (
                                            <Option key={reg.ID} value={reg.ID}>
                                                {reg.registration_name}
                                            </Option>
                                        ))}
                                    </Select>
                                </div>
                            )}

                            <Button type="primary" block size="large" onClick={handleWizardClick}>
                                Use Wizard
                            </Button>
                        </div>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default RegistrationSetupModal;
